import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'xp-back-button',
	standalone: true,
	imports: [CommonModule, MatIconModule],
	templateUrl: './xp-back-button.component.html',
	styleUrls: ['./xp-back-button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpBackButtonComponent {
	icon = input<string | null>(null);
	iconSrc = input<string | null>(null);
}
